import { type Order } from "@jti/magento";

import { type Currency } from "../../types/Currency.types";
import { calculatePrices } from "../calculatePrices";
import { getProductPrice } from "../getProductPrice";

export const getOrderItemsWithFormattedPrice = (
  order: Order | null,
  currency: Currency,
  showPricesWithTaxExcluded = false
): Order | undefined => {
  if (!order?.items) {
    return undefined;
  }

  const orderItems = order.items?.map((item) => ({
    ...item,
    price: getProductPrice(item, currency, showPricesWithTaxExcluded),
  }));
  const prices = order?.prices ? calculatePrices(order.prices, currency, showPricesWithTaxExcluded) : undefined;

  return {
    ...order,
    items: orderItems,
    prices,
  };
};
